/**
 * Input mode instructs browsers to display a different keyboard independent of the type attribute.
 * @see {@link https://css-tricks.com/everything-you-ever-wanted-to-know-about-inputmode/} for further information.
 */
export var InputMode;
(function (InputMode) {
    InputMode["Text"] = "text";
    InputMode["Phone"] = "tel";
    InputMode["Email"] = "email";
    InputMode["Numeric"] = "numeric";
    InputMode["Decimal"] = "decimal";
})(InputMode || (InputMode = {}));
//# sourceMappingURL=mode.js.map